import { useMutation } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { ICreateNode, IDeleteNode, IMoveNode, IUpdateNode } from 'ts/interfaces';
import { GET_ROOTNODES } from '../queries/Nodes';

export const MOVE_NODE = gql`
    mutation MoveNode($id: ID!, $positions: Int!) {
        moveNode(id: $id, positions: $positions) {
            id
        }
    }
`;

export const UPDATE_NODE = gql`
    mutation UseUpdateNode($id: ID!, $parent_id: Int, $node_attributes: String!) {
        updateNode(id: $id, parent_id: $parent_id, node_attributes: $node_attributes) {
            id
            parent_id
            node_attributes
        }
    }
`;

export const CREATE_NODE = gql`
    mutation UseCreateNode($parent_id: Int, $node_attributes: String!) {
        createNode(parent_id: $parent_id, node_attributes: $node_attributes) {
            parent_id
            node_attributes
            id
        }
    }
`;

export const DELETE_NODE = gql`
    mutation UseDeleteNode($id: ID!) {
        deleteNode(id: $id) {
            parent_id
            node_attributes
        }
    }
`;

const useGetMoveNode = ({ variables }: IMoveNode) => {
    return useMutation(MOVE_NODE, {
        variables,
        notifyOnNetworkStatusChange: false,
        fetchPolicy: 'no-cache',
    });
};

const useCreateNode = ({ variables }: ICreateNode) => {
    return useMutation(CREATE_NODE, {
        variables,
        awaitRefetchQueries: true,
        fetchPolicy: 'no-cache',
        refetchQueries: [{ query: GET_ROOTNODES }],
    });
};

const useDeleteNode = ({ variables }: IDeleteNode) => {
    return useMutation(DELETE_NODE, {
        variables,
        awaitRefetchQueries: true,
        fetchPolicy: 'no-cache',
        refetchQueries: [{ query: GET_ROOTNODES }],
    });
};

const useUpdateNode = ({ variables }: IUpdateNode) => {
    return useMutation(UPDATE_NODE, {
        variables,
        awaitRefetchQueries: true,
    });
};
export { useUpdateNode, useCreateNode, useDeleteNode, useGetMoveNode };
